import noticiaService from '../services/noticia.js';

export const useNoticia = () => {

    const getNoticiaByFechaCreacion = (language) => noticiaService.getAllByFechaCreacion(language);
    
    const getNoticiaByNumber = (noticiasToShow, language) => noticiaService.getLastByNumber(noticiasToShow, language);

    const getNoticiaByKey = (key, language) => noticiaService.getByKey(key, language);

    return {getNoticiaByFechaCreacion, getNoticiaByNumber, getNoticiaByKey};
}
